import React from 'react';
import { ISvgIconProps, } from './interface';
import { SvgIcon, } from './SvgIcon';

export const WidgetGridIcon = (props: ISvgIconProps) => {
  return <SvgIcon {...props}>
    <g fill="#444" transform="scale(0.0234375 0.0234375)"><path d="M854 342v-172h-172v172h172zM854 598v-172h-172v172h172zM854 854v-172h-172v172h172zM598 342v-172h-172v172h172zM598 598v-172h-172v172h172zM598 854v-172h-172v172h172zM342 342v-172h-172v172h172zM342 598v-172h-172v172h172zM342 854v-172h-172v172h172zM854 86q34 0 59 25t25 59v684q0 34-25 59t-59 25h-684q-34 0-59-25t-25-59v-684q0-34 25-59t59-25h684z" /></g>
  </SvgIcon>;
};
